import { connect } from 'react-redux';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

import AdminLoginComponent from './AdminLoginComponent';

export default connect(mapStateToProps, mapDispatchToProps)(AdminLoginComponent);
